<template>
    <div id="app" class="container">
        <Header v-if="!$route.meta.isHome"></Header>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <Footer v-if="!$route.meta.isHome"></Footer>
    </div>
</template>
<script>
    import Header from './components/Header.vue'
    import Footer from './components/Footer.vue'
    export default {
        name: 'App',
        components:{
            Header,
            Footer
        },
        watch:{
            $route(val){
                var that = this
                that.$nextTick(() => {
                    that.$zh_tran(localStorage.getItem('lang'))
                })
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            },
        },
        methods:{
        	changeLang() {
				let locale = localStorage.getItem('language')||'zh';
				var temp=locale === 'zh' ?  'en' : 'zh';
				this.$i18n.locale=temp;
				localStorage.language=temp;
			}
        },
        created(){
            if (this.$route.meta.skipGlobalInit) return;
            this.isUserLogged();
            var that = this
            that.$nextTick(() => {
                that.$zh_tran(localStorage.getItem('lang'))
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue